// src/components/ServiceSection.tsx
"use client";
import React from "react";

export function ServiceSection({
  id,
  title,
  children,
}: {
  id: string;
  title: string;
  children?: React.ReactNode;
}) {
  return (
    <section
      id={id}
      className="scroll-mt-28 flex flex-col relative max-w-[930px] mx-auto justify-center py-12"
    >
      <div className="w-full mx-auto">
        <h2 className="text-xl md:text-2xl font-extrabold tracking-tight text-purple-700 mb-6">
          {title}
        </h2>
        <div className="text-base md:text-lg leading-relaxed space-y-4">
          {children ?? (
            <p>
              Konten <strong>{title}</strong> belum tersedia. Kami sedang siapkan
              pengalaman dan studi kasus nyata yang akan membuatmu terinspirasi.
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
